import { DrawDashedLine } from "../utils/DrawDashedLine";
import { enumChartRenderOrder, enumFillMode, enumPanelRenderMode } from "../constants";
import { QElement } from "./QElement";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { Globals } from "./Globals";
import { XML_FillRect } from "../utils/XML_FillRect.js";

export class QMarginRect extends QElement {
  constructor() {
    super();
    this.fPageMgr = null;
    this.fParentPanel = null;
    this.fObjectName = "QMarginRect";
  }

  InitMarginRect(pageMgr, parentPanel) {
    this.fPageMgr = pageMgr;
    this.fParentPanel = parentPanel;

    //this.fDashImage = dashImage;
    this.SetAcceptsClicks(false);
    this.SetZPlane(enumChartRenderOrder.underlay);
  }

  DoRenderElement(drawBuffer) {
    var showPM = true;
    var showHF = true;
    var pm = this.fPageMgr;

    if (Globals._accountInfo.ReadOnlyMode()) return;
    if (this.fParentPanel.GetRenderMode() != enumPanelRenderMode.masterOnly) {
      showPM = pm.GetShowPageMargins();
      showHF = pm.GetShowHeaderFooter();

      if (showPM == false && showHF == false) return;
    }

    var ctx = drawBuffer.getContext("2d");

    ctx.strokeStyle = "#DDDDDD";
    ctx.lineWidth = 1;

    var sx = this.fHorzOffset + ThicknessAdjuster(1);
    var sy = this.fVertOffset + ThicknessAdjuster(1);
    var ex = sx + this.fWidth;
    var ey = sy + this.fHeight;

    if (showPM) {
      ctx.beginPath();
      ctx.moveTo(sx, sy);
      ctx.lineTo(ex, sy);
      ctx.lineTo(ex, ey);
      ctx.lineTo(sx, ey);
      ctx.lineTo(sx, sy);
      ctx.closePath();
      ctx.stroke();
    }

    if (showHF) {
      ctx.fillStyle = "#EEEEEE";

      var dashColor = this.fParentPanel.GetMarginLineColor();

      var hh = pm.GetHeaderHeight();
      if (hh != 0) {
        var hy = sy + hh;
        DrawDashedLine(ctx, 0, hy, ex + this.fHorzOffset, hy, 1, dashColor, 6, 13);
      }

      if (Globals._uiConfig.InBackgroundEditorMode()) {
        // Top rect
        ctx.save();
        ctx.fillStyle = "#b1b1b6";
        ctx.globalAlpha = 0.1;
        ctx.fillRect(0, 0, this.fWidth + this.fHorzOffset * 2, hy);
        ctx.restore();
        // Top area lines
        DrawDashedLine(ctx, ex * 0.25, 0, ex * 0.25, hy, 1, dashColor, 6, 13);
        DrawDashedLine(ctx, ex * 0.75, 0, ex * 0.75, hy, 1, dashColor, 6, 13);
      }

      var fh = pm.GetFooterHeight();
      if (fh != 0) {
        var fy = ey - fh;
        DrawDashedLine(ctx, 0, fy, ex + this.fHorzOffset, fy, 1, dashColor, 6, 13);
      }

      if (Globals._uiConfig.InBackgroundEditorMode()) {
        // Bottom rect
        ctx.save();
        ctx.fillStyle = "#b1b1b6";
        ctx.globalAlpha = 0.1;
        ctx.fillRect(0, fy, this.fWidth + this.fHorzOffset * 2, fy);
        ctx.restore();

        // Bottom area lines
        DrawDashedLine(ctx, ex * 0.25, fy, ex * 0.25, ey + this.fVertOffset, 1, dashColor, 6, 13);
        DrawDashedLine(ctx, ex * 0.75, fy, ex * 0.75, ey + this.fVertOffset, 1, dashColor, 6, 13);
      }
    }
  }

  // TORK- This is a temporary call to draw the mangins
  // Note: Background must be set to noFill for this to not get nuked by the background color
  // We could just use the gPublisherScaler here to get the full bounds and then inset with the adjusted margin
  DoAltRender(altCanvas) {
    return;

    var altCanvasType = altCanvas.GetCanvasType();
    var altCanvasElement = altCanvas.GetCanvasElement();

    if (Globals._publishScaler) {
      var pageSize = Globals._publishScaler.GetOutputPageSize();
      var pageMargins = Globals._publishScaler.GetOutputMargins();
      var sx = pageMargins.fLeft;
      var sy = pageMargins.fTop;
      var w = pageSize.fX - pageMargins.fLeft - pageMargins.fRight;
      var h = pageSize.fY - pageMargins.fTop - pageMargins.fBottom;
      var bkGroundColor = "#A98765";
    } else {
      sx = this.fHorzOffset;
      sy = this.fVertOffset;
      w = this.fWidth;
      h = this.fHeight;
      bkGroundColor = "#005500";
    }

    var fillMode = enumFillMode.solidFill;
    // var layer = this.GetLayer();

    if (!Globals._pubSettings.fTransparentBackground) {
      if (fillMode == enumFillMode.solidFill) {
        switch (altCanvasType) {
          case "XML":
            XML_FillRect(sx, sy, w, h, bkGroundColor, null, altCanvasElement, -1);
            break;
        }
      }
    }
  }

  //=================================================================================================
  // Debugging
  ObjectName() {
    return this.fObjectName;
  }
}
